import { render, staticRenderFns } from "./RaceTable.vue?vue&type=template&id=721f6091&scoped=true&"
import script from "./RaceTable.vue?vue&type=script&lang=ts&"
export * from "./RaceTable.vue?vue&type=script&lang=ts&"
import style0 from "./RaceTable.vue?vue&type=style&index=0&id=721f6091&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721f6091",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
